(function(){
    'use strict'

    angular.module('app.empleados')
    .factory('EmpleadosService', EmpleadosService);

    EmpleadosService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function EmpleadosService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove,
            getExcelFile: getExcelFile,
            getAllSalariosMensuales: getAllSalariosMensuales,
            getByIdSalariosMensuales:getByIdSalariosMensuales,
            saveSalarioPromedioMensual: saveSalarioPromedioMensual,
            updateSalarioPromedioMensual: updateSalarioPromedioMensual,
            removeSalarioPromedioMensual: removeSalarioPromedioMensual,
            getPromedioMensualPeriodos: getPromedioMensualPeriodos
        };

        return api;

        function getAll(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/empleados/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        //Prueba de Concepto
        function getExcelFile(searchCriteria){
            
            var nombreParam = searchCriteria.nombre === '' ? 'undefined' : searchCriteria.nombre;
            var identificacionParam = searchCriteria.identificacion === '' ? 'undefined' : searchCriteria.identificacion;
            var departamentoParam = searchCriteria.departamentoId;
            var puestoParam = searchCriteria.puestoId;
            var tipoPlanillaParam = searchCriteria.tipoPlanillaId;
            var estado = searchCriteria.estado;

            var url = `api/empleados/excel/${searchCriteria.companiaId}/${nombreParam}/${identificacionParam}/${departamentoParam}/${puestoParam}/${tipoPlanillaParam}/${estado}`;
            return $http.get(apiSettings.apiBaseUrl + url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });

        };

        function getById(companiaId, empleadoId){

            var url = apiSettings.apiBaseUrl + 'api/empleados/' + companiaId + '/' + empleadoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(empleado){

            empleado.id = 0;
            empleado.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/empleados',  
                method: 'POST',  
                data: empleado
            });  
            return response;
        };

        function update(empleado){

            empleado.companiaId = UserInfoService.getCompaniaId();

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/empleados',  
                method: 'PUT',  
                data: empleado
            });  
            return response;
        };

        function remove(empleado){

            empleado.companiaId = UserInfoService.getCompaniaId();
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/empleados',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: empleado
            });  
            return response;
        };

        function getAllSalariosMensuales(companiaId, empleadoId){

            var url = apiSettings.apiBaseUrl + 'api/salario-promedio-mensual/' + companiaId + '/' + empleadoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function getByIdSalariosMensuales(companiaId, empleadoId, anno, mes){

            var url = apiSettings.apiBaseUrl + 'api/salario-promedio-mensual/' + companiaId + '/' + empleadoId  + '/' + anno + '/' + mes;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function saveSalarioPromedioMensual(salario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/salario-promedio-mensual/',  
                method: 'POST',  
                data: salario
            });  
            return response;
        };

        function updateSalarioPromedioMensual(salario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/salario-promedio-mensual/',  
                method: 'PUT',  
                data: salario
            });  
            return response;
        };

        function removeSalarioPromedioMensual(salario){
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/salario-promedio-mensual/',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: salario
            });  
            return response;
        };

        function getPromedioMensualPeriodos(){

            var url = apiSettings.apiBaseUrl + 'api/salario-promedio-mensual/periodos/';
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

    };

})();